export default __webpack_public_path__ + "static/media/settings_c.92616462.png";